/**
 * Turnos de los pedidos de la lista de Creaciones
 * (ADR-2026-10-08-creaciones-un-pedido-de-la-lista-a-la-vez).
 *
 * `fetchImages` se llama desde varios lados que pueden pisarse: la carga al entrar, el
 * efecto que pone la marca activa (cuentas de 2+ marcas), el refetch silencioso cuando
 * termina una tanda y "cargar más". Sin turnos, el que terminaba primero apagaba `loading`,
 * la grilla se dibujaba y después aterrizaba el otro REEMPLAZANDO la lista sobre `<img>` ya
 * montadas. Las que recibían la misma URL (la firma sale de la caché de 50 min: las
 * creaciones más nuevas, que ya firmó la columna del modo o el panel de recientes) no se
 * volvían a cargar, su `onLoad` no se disparaba y el indicador de la celda quedaba girando
 * para siempre — "las últimas no cargan y las anteriores sí".
 *
 * Reglas:
 * - Un **reemplazo** nuevo deja sin efecto a todo lo que esté en vuelo: sólo el último
 *   escribe la lista y sólo él apaga la carga. Así un reemplazo siempre aterriza con la
 *   grilla en el esqueleto, que es lo que supone `miniaturasEnCarga`.
 * - Un **silencioso** que llega con un reemplazo en vuelo pasa a ser reemplazo: la query
 *   de atrás pudo salir antes de que existieran las filas nuevas, y la grilla ya está en
 *   el esqueleto, así que no hay parpadeo que evitar.
 * - **"Cargar más"** con un reemplazo en vuelo no se aplica: sumaría una página de la
 *   lista vieja.
 */
export type TipoDePedido = "reemplazar" | "silencioso" | "mas";

export type PedidoDeLaLista = {
  /** El tipo con que se aplica (un silencioso puede volverse reemplazo). */
  tipo: TipoDePedido;
  /** Si sus filas todavía se pueden escribir en la lista. */
  vigente: () => boolean;
  /** Si le toca apagar `loading` al terminar. */
  apagaLaCarga: () => boolean;
  /** Llamarlo al terminar (en el `finally`), haya salido bien o no. */
  terminar: () => void;
};

export function crearTurnosDeLaLista() {
  let ultimoReemplazo = 0;
  let reemplazoEnVuelo: number | null = null;

  return {
    empezar(pedido: TipoDePedido): PedidoDeLaLista {
      const habiaReemplazo = reemplazoEnVuelo !== null;
      const tipo: TipoDePedido =
        pedido === "silencioso" && habiaReemplazo ? "reemplazar" : pedido;
      const reemplaza = tipo === "reemplazar";
      const turno = reemplaza ? ++ultimoReemplazo : ultimoReemplazo;
      if (reemplaza) reemplazoEnVuelo = turno;
      const nacioVencido = tipo === "mas" && habiaReemplazo;
      const vigente = () => !nacioVencido && turno === ultimoReemplazo;
      return {
        tipo,
        vigente,
        apagaLaCarga: () => reemplaza && vigente(),
        terminar: () => {
          if (reemplaza && reemplazoEnVuelo === turno) reemplazoEnVuelo = null;
        },
      };
    },
  };
}
